import React from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import moment from "moment";
import GlobalApi from "./../../Global";
import refresh_token from "./../../Global/refresh_token";
import Spinner from "./../../Global/Spinner";
import {
  Paper,
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Container,
  Button,
  TableHead,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  TableContainer,
  Grid,
} from "@material-ui/core";
import _ from "lodash";
import { useHistory, useParams } from "react-router-dom";
import TextInputCustom from "./TextInput";
import { makeStyles, withStyles } from "@material-ui/styles";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import NotInterestedIcon from "@material-ui/icons/NotInterested";
import swal from "@sweetalert/with-react";
import DarkButton from "./../../Global/DarkButton";
import {useTranslation} from 'react-i18next';

import Colors from "./../../Global/colors";
import { useSelector } from "react-redux";
//uzairs key
//  var Publishable_Key =
//    "pk_test_51ITmyWJ4vK1axxmlx5rddPBMMR0udB1cGkis6AUKZs9K8LABCr9Yf8TdUs5PtRUsRdOMmpmpUnnShBAp5BRHxYZ600byCAZmpy";

  //  var Publishable_Key ="pk_test_51HcU2KJujscxg7NdloR1gKvg06CP7jCuDcdlvOpvsiGgH91ZS7wS53JN3cjRGhna4BF4OaFlKnhJrnuAXPETsPjI00Z0KLhza1"

var Publishable_Key =
  "pk_live_51HcU2KJujscxg7NdYzTFCAzbKB98k2TH38CypRPMSDDDLgt7q2LvF1FBfwvWdghzwcjrtn9mQGQPuOGXipqldCqS00xeqkmTpQ";

const stripePromise = loadStripe(Publishable_Key);


// const useStyles = makeStyles((theme) => ({
//   root: {
//     ':hover': {
//         backgroundColor: Colors.primaryColor,
//       },
//   },
//   tableBorder: {
//     // borderWidth: 0,
//     borderWidth: 1,
//     borderColor: "#f0f2f5",
//     borderStyle: "solid",
//   },
//   tableBorderRight: {
//     borderWidth: 0,
//     // borderRightWidth: 1,
//     color: "#222",
//     borderRadius: 0,
//     borderColor: "#f0f2f5",
//     borderStyle: "solid",
//     textTransform: "uppercase",
//   },
// }));

function AddPackagePlan() {
  const history = useHistory();
  const {t} = useTranslation();
  const language = useSelector((state) => state.languageReducer.language);
  // const { package_type, is_monthly } = useParams();
  const [is_monthly, set_is_monthly]= React.useState("Monthly");
  const [package_type, set_package_type]= React.useState("");
  const [usagePurpose, setUsagePurpose] = React.useState("");
  const [noOfUsers, setNoOfUsers] = React.useState(1);
  const [showBill, setShowBill] = React.useState(false);
  //   const [pricing, setPricing] = React.useState({});
  const [previousPackage, setPreviousPackage] = React.useState({});
  const [pricing, setPricing] = React.useState({});
  const [packageId, setPackageId] = React.useState({});
  const [organization, setOrganization] = React.useState({});
  const [currency, setCurrency] = React.useState("doller");
  //   const classes = useStyles();
  const [loader, setLoader] = React.useState(false);
  const [successMessage, setSuccessMessage] = React.useState(false);
  const [currentPackage, setCurrentPackage] = React.useState({});
  const [currentTeamSize, setCurrentTeamSize] = React.useState(0);

  const stripe = useStripe();
  const elements = useElements();


  const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: "pink",
      color: "blue",
    },
    body: {
      fontSize: 14,
      textAlign:language=="ar"?"right":"left",
    },
  }))(TableCell);
  
  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: "#f7f7f7",
      },
      "&:hover": {
        background: Colors.primaryColor,
      },
    },
  }))(TableRow);


  const handleSubmit = async (event) => {
    // Block native form submission.
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }

    // Get a reference to a mounted CardElement. Elements knows how
    // to find your CardElement because there can only ever be one of
    // each type of element.
    const cardElement = elements.getElement(CardElement);

    // Use your card Element with other Stripe.js APIs
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: cardElement,
    });

    if (error) {
      console.log("[error]", error);
    } else {
      console.log("[PaymentMethod]", paymentMethod);
    }
  };

  function getPricing() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      payment_type: "pound",
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/PricingModule/get_all_pricing_modules?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          let grouped_res = await _.groupBy(response.data, (v) => v.title);
          let obj_package = {};
          let final_grouped_res = {};
          await Object.keys(grouped_res).map(async (key, mainI) => {
            let obj = await _.groupBy(
              grouped_res[key][0]?.PricingFeatures,
              (v) => v.title
            );
            final_grouped_res[key] = obj;
            if (mainI === Object.keys(grouped_res).length - 1) {
              await Object.keys(final_grouped_res).map(async (key1) => {
                await Object.keys(final_grouped_res[key1]).map(async (key2) => {
                  let obj = await _.groupBy(
                    final_grouped_res[key1][key2],
                    (v) => v?.Package?.title
                  );
                  final_grouped_res[key1][key2] = obj;
                  obj_package = obj;
                });
              });
              setPricing(final_grouped_res);

              let package_ids = {};
              await Object.keys(obj_package).map((key) => {
                package_ids[key] = obj_package[key][0].Package.id;
              });
              setPackageId(package_ids);
            }
          });
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          if (status) {
            getPricing();
          }
        }
      })
      .catch((error) => console.log(error.message));
  }
  function getPackage(packageID) {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      package_id: packageID,
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Package/get_package?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log("response from get current Package", response)
        if (response.status === "Success") {
          console.log(response.data);

          setCurrentPackage(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          if (status) {
            getPackage();
          }
        }
      })
      .catch((error) => console.log(error.message));
  }

  function getCurrentTeamSize() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      organization_id: data.organization_id,
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/user/get_users_count?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          console.log(response.data);

          setCurrentTeamSize(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          if (status) {
            getCurrentTeamSize();
          }
        }
      })
      .catch((error) => console.log(error.message));
  }

  React.useEffect(() => {
    getUserPackageDetails()
   
    getCurrentTeamSize();
  }, []);

  React.useEffect(() => {
    getPricing();
    getPackageDetail();
    getOrganization();
  }, []);

  const getUserPackageDetails = () =>{
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;


    let params = {
      user_id:data.user_id,
      organization_id: data.organization_id,
    };
    // console.log(data.user_id);
    //alert(JSON.stringify(params))
    //console.log(params);
     //return
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");


     fetch(GlobalApi + "/Package/get_user_license_details?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log("response from user license details : " , response)
        if (response.msg === "success") {
          set_package_type(response.package.package_id);
          setCurrentPackage(response.package.package);
          // getPackage(response.package.package_id);
          // swal(
          //   t("Success"),
          //   "Uraudits sales team will contact you soon",
          //   "success"
          // );
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          if (status) {
            getUserPackageDetails();
          }
        }
      })
      .catch((error) => console.log(error.message));

  }

  async function handlePurchase(total,
    price_per_user,
    yearly_price,
    price_per_user_in_pound,
    yearly_price_in_pound,
    vst,
    monthly_total) {
    console.log("hehehe", total);

    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }

    // Get a reference to a mounted CardElement. Elements knows how
    // to find your CardElement because there can only ever be one of
    // each type of element.
    const cardElement = elements.getElement(CardElement);

    // // Use your card Element with other Stripe.js APIs
    const payment_obj = await stripe.createToken(cardElement);

    // // console.log(payment_obj)
    // // return

    if (payment_obj.error) {
      console.log("[error]", payment_obj.error);
      setLoader(false);
      // swal(t("Warning"), "Please fill out payment form correctly")
    } else {
      // console.log("[PaymentMethod]", payment_obj);
      fetch(GlobalApi + "/Admin/payment_for_licenses", {
        method: "post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify({
          payment_type:currency,
          amount: total,
          total,
          subscription_type: is_monthly,
          id: payment_obj?.token?.id,
          is_monthly:is_monthly,
          price_per_user: is_monthly == "Monthly" ? price_per_user : yearly_price,
          yearly_price:yearly_price,
          price_per_user_in_pound: is_monthly == "Monthly" ? price_per_user_in_pound : yearly_price_in_pound,
          yearly_price_in_pound:yearly_price_in_pound,
          vst:0,
          monthly_total:
          is_monthly == "Monthly"
          ? parseFloat(monthly_total)
          : parseFloat(monthly_total) * 12,
          no_of_users: noOfUsers,
          organization_id: organization.id,
          package_name: currentPackage?.title,
        }),
      })
        .then((data1) => data1.json())
        .then((res) => {
          if(res.status == "Success"){
            fetch(GlobalApi + "/Package/increase_no_of_licenses", {
              method: "post",
              headers: new Headers({
                Authorization: "Bearer " + token,
                "Content-Type": "application/json",
              }),
              body: JSON.stringify({
                payment_type:currency,
                amount: total,
                total,
                subscription_type: is_monthly,
                is_monthly:is_monthly,
                price_per_user: is_monthly == "Monthly" ? price_per_user : yearly_price,
                yearly_price:yearly_price,
                price_per_user_in_pound: is_monthly == "Monthly" ? price_per_user_in_pound : yearly_price_in_pound,
                yearly_price_in_pound:yearly_price_in_pound,
                vst:0,
                monthly_total:is_monthly == "Monthly" ? parseFloat(monthly_total): parseFloat(monthly_total) * 12,
                package_name: currentPackage?.title,          
                package_id: package_type,
                organization_id: data.organization_id,
                expiry_date: is_monthly == "Monthly" ? moment().add(1, "M"): moment().add(1, "years"),
                status: "active",
                no_of_users: noOfUsers,
                no_of_months: is_monthly == "Monthly" ? 1 : 12,
                file_size_per_user:is_monthly == "Monthly" ? currentPackage?.file_size_per_user : parseInt(currentPackage?.file_size_per_user) * 12,
                total_amount:total
              }),
            })
              .then(async (response) => {
                swal(t("Success"), t("License Ad Succesfully!"), "success");
                // setCurrentPackage(response.data);
                let request = await fetch(
                  GlobalApi + "/Organization/edit_organization",
                  {
                    method: "Post",
                    headers: new Headers({
                      Authorization: "Bearer " + token,
                      "Content-Type": "application/json",
                    }),
                    body: JSON.stringify({
                      organization_id: data.organization_id,
                      usage_purpose: usagePurpose,
                    }),
                  }
                );
                history.push("/billing");
                // window.location.reload()
              })
              .catch((err) => console.log(err));
          }else{
            swal(t("Warning"), res.error , "warning");
            setLoader(false)
            history.goBack()
          }
         
        });
    }
  }

  function continueToBilling(total1) {
    console.log("&&&&&&&&&&&&&&&&_________________________&&&&&&&&&&&&&&&",
      currentPackage?.title,
      noOfUsers,
      usagePurpose
    );

    if(noOfUsers == 0 || !noOfUsers){
swal(
            t("Warning"),
            t("Atleast oe License Required"),
            "warning"
          );
    }else{
      if (noOfUsers >= 15) {
        let total =
          is_monthly == "Monthly"
            ? parseFloat(
                is_monthly == "Monthly"
                  ? (currency == "doller" ? currentPackage?.price_per_user : currentPackage?.price_per_user_in_pound)
                  : (currency == "doller" ? currentPackage?.yearly_price : currentPackage?.yearly_price_in_pound)
              ) *
                parseFloat(noOfUsers) 
              //   +
              // parseFloat(
              //   is_monthly == "Monthly"
              //     ? currentPackage?.price_per_user
              //     : currentPackage?.yearly_price
              // ) *
              //   parseFloat(noOfUsers) * 0.2
                
            : (parseFloat(
                is_monthly == "Monthly"
                  ? (currency == "doller" ? currentPackage?.price_per_user : currentPackage?.price_per_user_in_pound)
                  : (currency == "doller" ? currentPackage?.yearly_price : currentPackage?.yearly_price_in_pound)
              ) *
                parseFloat(noOfUsers)
                //  +
                // parseFloat(
                //   is_monthly == "Monthly"
                //     ? currentPackage?.price_per_user
                //     : currentPackage?.yearly_price
                // ) *
                //   parseFloat(noOfUsers) * 0.2
                  ) *
              12;
        handleEmail(
          total,
          noOfUsers,
          is_monthly,
          currentPackage?.price_per_user,
          currentPackage?.yearly_price,
          currentPackage?.price_per_user_in_pound,
          currentPackage?.yearly_price_in_pound,
          // parseFloat(
          //   is_monthly == "Monthly"
          //     ? currentPackage?.price_per_user
          //     : currentPackage?.yearly_price
          // ) *
          //   parseFloat(noOfUsers) *
          //   0.2,
          0,
          parseFloat(
            is_monthly == "Monthly"
              ? (currency == "doller" ? currentPackage?.price_per_user : currentPackage?.price_per_user_in_pound)
              : (currency == "doller" ? currentPackage?.yearly_price : currentPackage?.yearly_price_in_pound)
          ) * parseFloat(noOfUsers)
        );
      } else {
        setShowBill(true);
      }
    }
   
  }

  function handleEmail(
    total,
    noOfUsers,
    is_monthly,
    price_per_user,
    yearly_price,
    price_per_user_in_pound,
    yearly_price_in_pound,
    vst,
    monthly_total
  ) {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      total,
      noOfUsers,
      is_monthly,
      price_per_user: is_monthly == "Monthly" ? price_per_user : yearly_price,
      yearly_price,
      //vst: is_monthly == "Monthly" ? vst : vst * 12,
      vst:0,
      monthly_total:
        is_monthly == "Monthly"
          ? parseFloat(monthly_total)
          : parseFloat(monthly_total) * 12,
      organization_name: organization.organization_name,
      email: organization.email,
      organization_id: organization.id,
      no_of_users: noOfUsers,
      package_name: currentPackage?.title,
    };
    // console.log(data.user_id);
    //alert(JSON.stringify(params))
    //console.log(params);
     //return
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Admin/send_email_admin?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          
          setSuccessMessage(true);
          setLoader(false);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          if (status) {
            getOrganization();
          }
        }
      })
      .catch((error) => console.log(error.message));
  }

  function getPackageDetail() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      organization_id: data?.organization_id,
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Package/get_package_history?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          // console.log(response.data);
          // if (
          //   new Date().getTime() > new Date(response.data.expiry_date).getTime()
          // ) {
          //   setExpired(true);
          // }
          setPreviousPackage(response.data);
          // setNoOfUsers(response.data.no_of_users);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          if (status) {
            getPackageDetail();
          }
        }
      })
      .catch((error) => console.log(error.message));
  }

  function getOrganization() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      organization_id: data?.organization_id,
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Organization/get_organization?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          console.log(response.data);
          // if (
          //   new Date().getTime() > new Date(response.data.expiry_date).getTime()
          // ) {
          //   setExpired(true);
          // }
          setOrganization(response.data);
          setUsagePurpose(response.data.usage_purpose);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          if (status) {
            getOrganization();
          }
        }
      })
      .catch((error) => console.log(error.message));
  }

  // console.log(previousPackage);

  if (pricing === null) {
    return <Spinner />;
  } else {
    return <div className="" style={{ padding: "0px", display: "flex", flexDirection: "column", overflow: "auto" }}>
        <div className="" style={{ padding: 20, textAlign: "left", overflowY: "scroll", backgroundColor: Colors.globalColor9 }}>
          {successMessage === false ? <div style={{ overflow: "auto" }}>
              <Paper className="shadow" style={{ margin: "0px 5px", padding: 20, marginBottom: 10, borderRadius: "10px" }} variant="outlined">
                <Grid container>
                  <Grid xs={6} sm={4} lg={3} className="hover cursor" onClick={() => setShowBill(false)}>
                    <Grid container>
                      <Grid item xs={12} align="center">
                        <div style={{ backgroundColor: Colors.buttonTextColor, padding: 10, width: 50, height: 50, borderRadius: 25 }}>
                          <Typography variant="h5" style={{ color: "#fff", textAlign: "center" }}>
                            1
                          </Typography>
                        </div>
                      </Grid>
                      <Grid item xs={12} align="center">
                        <Typography variant="h6" style={{ textAlign: "center", marginTop: 10 }}>
                          {t("Selected Package")}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid xs={6} sm={4} lg={3}>
                    <Grid container>
                      <Grid item xs={12} align="center">
                        <div style={{ backgroundColor: showBill === true ? Colors.buttonTextColor : "lightgray", padding: 10, width: 50, height: 50, borderRadius: 25 }}>
                          <Typography variant="h5" style={{ color: "#fff", textAlign: "center" }}>
                            2
                          </Typography>
                        </div>
                      </Grid>
                      <Grid item xs={12} align="center">
                        <Typography variant="h6" style={{ textAlign: "center", marginTop: 10 }}>
                          {t("Payment")}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Paper>

              {showBill === false ? <>
                  <Paper className="shadow" style={{ margin: "0px 5px", padding: 20, marginBottom: 10, borderRadius: "10px" }} variant="outlined">
                    {" "}
                    <>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} lg={6}>
                          <Typography variant="h5" style={{textAlign:language=="ar" && "right" }}>{t("Add licenses")}</Typography>
                          <Grid container spacing={3}>
       
                            <Grid item xs={12} sm={12} lg={9} style={{textAlign:language=="ar" && "right" }}>
                              <Typography variant="p" style={{textAlign:language=="ar" && "right" }}>
                                {t("How many licences will you require?")}
                              </Typography>
                              <br />
                              <br />
                              <TextInputCustom state="noOfUsers" onChange={(e) => {
                                  const re = /^[0-9\b]+$/;

                                  // if value is not blank, then test the regex

                                  if (e.target.value === "" || re.test(e.target.value)) {
                                    setNoOfUsers(e.target.value);
                                  }
                                }} value={noOfUsers || ""} type="number" label={t("Number of License")} InputProps={{ inputProps: { min: 1 } }} size={"large"} />
                            </Grid>
                            <Grid item xs={12} sm={12} lg={9}>
                              <FormControl fullWidth variant="outlined" size="small" style={{ marginTop: "10px" }}>
                                <InputLabel id="demo-simple-select-outlined-label">
                                  {t("Select Currency")}
                                </InputLabel>

                                <Select fullWidth labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined" value={currency} onChange={(e) => setCurrency(e.target.value)} label="usagePurpose" size="small">
                                  <MenuItem value={"doller"}>
                                    {t("Dollar")}
                                  </MenuItem>
                                  <MenuItem value={"pounds"}>
                                    {t("Pounds")}
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={12} lg={9}>
                              <FormControl fullWidth variant="outlined" size="small" style={{ marginTop: "10px" }}>
                                <InputLabel id="demo-simple-select-outlined-label">
                                  {t("Select Subscription")}
                                </InputLabel>

                                <Select fullWidth labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined" value={is_monthly} onChange={(e) => set_is_monthly(e.target.value)} label="usagePurpose" size="small">
                                  <MenuItem value={"Monthly"}>
                                    {t("Monthly")}
                                  </MenuItem>
                                  <MenuItem value={"Yearly"}>
                                    {t("Yearly")}
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={12} sm={6} lg={6}>
                          {/* {showBill == true && ( */}
                          <TableContainer style={{ borderTop: "1px solid #dadada", borderRight: "1px solid #dadada", borderLeft: "1px solid #dadada",textAlign:language=="ar" && "right" }}>
                            <Table>
                              <TableBody>
                                <StyledTableRow>
                                  <StyledTableCell>{t("Package")}</StyledTableCell>
                                  <StyledTableCell>
                                    {currentPackage?.title}
                                  </StyledTableCell>
                                </StyledTableRow>
                                <StyledTableRow>
                                  <StyledTableCell>
                                    {t("Subscription")}
                                  </StyledTableCell>
                                  <StyledTableCell>
                                    {is_monthly}
                                  </StyledTableCell>
                                </StyledTableRow>
                                <StyledTableRow>
                                  <StyledTableCell>
                                   {t("Price Per User")}
                                  </StyledTableCell>
                                  <StyledTableCell>
                                    {currency == "doller" ? "$" : "£"}
                                    {is_monthly == "Monthly" ? (currency == "doller" ? currentPackage?.price_per_user : currentPackage?.price_per_user_in_pound) : currency == "doller" ? currentPackage?.yearly_price : currentPackage?.yearly_price_in_pound}
                                  </StyledTableCell>
                                </StyledTableRow>
                                <StyledTableRow>
                                  <StyledTableCell>
                                    {t("Sub Total")}
                                  </StyledTableCell>
                                  <StyledTableCell>
                                    {is_monthly == "Monthly" ? (currency == "doller" ? currentPackage?.price_per_user : currentPackage?.price_per_user_in_pound) : currency == "doller" ? currentPackage?.yearly_price : currentPackage?.yearly_price_in_pound} X {noOfUsers} {is_monthly == "Monthly" ? "" : " X 12"} = {currency == "doller" ? "$" : "£"}
                                    {parseFloat(is_monthly == "Monthly" ? (currency == "doller" ? currentPackage?.price_per_user : currentPackage?.price_per_user_in_pound) * parseFloat(noOfUsers) : (currency == "doller" ? currentPackage?.yearly_price : currentPackage?.yearly_price_in_pound) * parseFloat(noOfUsers) * 12).toFixed(2)}
                                  </StyledTableCell>  
                                </StyledTableRow>
                                <StyledTableRow>
                                  {/* <StyledTableCell>20% VAT</StyledTableCell>
                                <StyledTableCell>
                                  $
                                  {(
                                    parseFloat(
                                      is_monthly == "Monthly"
                                        ? currentPackage?.price_per_user
                                        : currentPackage?.yearly_price * 12
                                    ) *
                                    parseFloat(noOfUsers) *
                                    0.2
                                  ).toFixed(2)}
                                </StyledTableCell> */}
                                </StyledTableRow>
                                {is_monthly == "Monthly" && <StyledTableRow>
                                    <StyledTableCell>
                                      {t("Total Monthly")}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                      {/* {parseFloat(is_monthly == "Monthly"
                        ? currentPackage?.price_per_user
                        : currentPackage?.yearly_price) *
                        parseFloat(noOfUsers)}{" "}
                      +
                      {(
                        parseFloat(is_monthly == "Monthly"
                        ? currentPackage?.price_per_user
                        : currentPackage?.yearly_price) *
                        parseFloat(noOfUsers) *
                        0.2
                      ).toFixed(2)}
                      =  */}${(parseFloat(is_monthly == "Monthly" ? (currency == "doller" ? currentPackage?.price_per_user : currentPackage?.price_per_user_in_pound) : currency == "doller" ? currentPackage?.yearly_price : currentPackage?.yearly_price_in_pound) * parseFloat(noOfUsers))
                                        //   +
                                        // parseFloat(
                                        //   is_monthly == "Monthly"
                                        //     ? currentPackage?.price_per_user
                                        //     : currentPackage?.yearly_price
                                        // )
                                        //   * parseFloat(noOfUsers) * 0.2

                                        .toFixed(2)}
                                    </StyledTableCell>
                                  </StyledTableRow>}
                                {is_monthly !== "Monthly" && <StyledTableRow>
                                    <StyledTableCell>
                                      {t("Total Yearly")}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                      ${(parseFloat(is_monthly == "Monthly" ? (currency == "doller" ? currentPackage?.price_per_user : currentPackage?.price_per_user_in_pound) : currency == "doller" ? currentPackage?.yearly_price : currentPackage?.yearly_price_in_pound) * parseFloat(noOfUsers) * //   is_monthly == "Monthly" // parseFloat( // +
                                        //     ? currentPackage?.price_per_user
                                        //     : currentPackage?.yearly_price
                                        // )
                                        //   * parseFloat(noOfUsers) * 0.2
                                        12).toFixed(2)}
                                    </StyledTableCell>
                                  </StyledTableRow>}
                              </TableBody>
                            </Table>
                          </TableContainer>
                          {/* )} */}
                        </Grid>
                        {<Grid item xs={12} align="right">
                            <Button variant="contained" type="submit" className="addBtn" component="span" onClick={() => continueToBilling(is_monthly == "Monthly" ? parseFloat(is_monthly == "Monthly" ? (currency == "doller" ? currentPackage?.price_per_user : currentPackage?.price_per_user_in_pound) : currency == "doller" ? currentPackage?.yearly_price : currentPackage?.yearly_price_in_pound) * parseFloat(noOfUsers) : //   is_monthly == "Monthly" // parseFloat( // +
                                      //     ? currentPackage?.price_per_user
                                      //     : currentPackage?.yearly_price
                                      // ) *
                                      //   parseFloat(noOfUsers) *  0.2

                                      parseFloat(is_monthly == "Monthly" ? (currency == "doller" ? currentPackage?.price_per_user : currentPackage?.price_per_user_in_pound) : currency == "doller" ? currentPackage?.yearly_price : currentPackage?.yearly_price_in_pound) * parseFloat(noOfUsers) * //   is_monthly == "Monthly" // parseFloat( // +
                                        //     ? currentPackage?.price_per_user
                                        //     : currentPackage?.yearly_price
                                        // ) *
                                        // parseFloat(noOfUsers) * 0.2
                                        12)}>
                              {t("Next")}
                            </Button>
                          </Grid>}
                      </Grid>
                    </>
                  </Paper>
                </> : <Paper className="shadow" style={{ padding: 20, marginBottom: 10, borderRadius: "10px", margin: "0px 5px" }} variant="outlined">
                  {/* {(is_monthly == "Monthly" ? parseFloat(is_monthly == "Monthly" ? (currency == "doller" ? currentPackage?.price_per_user : currentPackage?.price_per_user_in_pound) : currency == "doller" ? currentPackage?.yearly_price : currentPackage?.yearly_price_in_pound) * parseFloat(noOfUsers) : parseFloat(is_monthly == "Monthly" ? (currency == "doller" ? currentPackage?.price_per_user : currentPackage?.price_per_user_in_pound) : currency == "doller" ? currentPackage?.yearly_price : currentPackage?.yearly_price_in_pound) * parseFloat(noOfUsers) * 12) < 1500 ? <CardElement /> : null} */}

                  {noOfUsers < 15 ? <CardElement /> : null}

                  <Button variant="contained" type="submit" className="addBtn" component="span" disabled={loader} size="small" onClick={() => {
                      // onClick={handleSubmit}
                      setLoader(true);
                      let total = is_monthly == "Monthly" ? parseFloat(is_monthly == "Monthly" ? (currency == "doller" ? currentPackage?.price_per_user : currentPackage?.price_per_user_in_pound) : currency == "doller" ? currentPackage?.yearly_price : currentPackage?.yearly_price_in_pound) * parseFloat(noOfUsers) : //   is_monthly == "Monthly" // parseFloat( //   +
                            //     ? currentPackage?.price_per_user
                            //     : currentPackage?.yearly_price
                            // ) *
                            //   parseFloat(noOfUsers) * 0.2

                            parseFloat(is_monthly == "Monthly" ? (currency == "doller" ? currentPackage?.price_per_user : currentPackage?.price_per_user_in_pound) : currency == "doller" ? currentPackage?.yearly_price : currentPackage?.yearly_price_in_pound) * parseFloat(noOfUsers) * //   is_monthly == "Monthly" // parseFloat( // +
                            //     ? currentPackage?.price_per_user
                            //     : currentPackage?.yearly_price
                            // ) *
                            //   parseFloat(noOfUsers) * 0.2
                            12;

                      noOfUsers < 15 ? handlePurchase(total, currentPackage?.price_per_user, currentPackage?.yearly_price, currentPackage?.price_per_user_in_pound, currentPackage?.yearly_price_in_pound, 0, parseFloat(is_monthly == "Monthly" ? currentPackage?.price_per_user : currentPackage?.yearly_price) * parseFloat(noOfUsers)) : handleEmail(total, noOfUsers, is_monthly, currentPackage?.price_per_user, currentPackage?.yearly_price, currentPackage?.price_per_user_in_pound, currentPackage?.yearly_price_in_pound, //     ? currentPackage?.price_per_user //   is_monthly == "Monthly" // parseFloat(
                            //     : currentPackage?.yearly_price
                            // ) *
                            //   parseFloat(noOfUsers) * 0.2
                            0, parseFloat(is_monthly == "Monthly" ? (currency == "doller" ? currentPackage?.price_per_user : currentPackage?.price_per_user_in_pound) : currency == "doller" ? currentPackage?.yearly_price : currentPackage?.yearly_price_in_pound) * parseFloat(noOfUsers));
                    }}>
                    {loader ? "Please Wait ..." : t("Proceed to checkout")}
                  </Button>
                </Paper>}
            </div> : <Paper variant="outlined" style={{ padding: 20, textAlign: "center", fontWeight: "bold" }}>
              <Typography variant="h4" style={{ color: Colors.buttonTextColor }}>
                {t("Your Request has been sent")}
              </Typography>
              <Typography variant="p">
                {t("Uraudits support team will contact you soon")}
              </Typography>
            </Paper>}
        </div>
      </div>;
  }
}

export default function AddPackagePlanContainer(props) {
  return (
    <Elements stripe={stripePromise}>
      <AddPackagePlan {...props} />
    </Elements>
  );
}
